import React from 'react';

const Overlay = ({ events, currentTime }) => {
  // Extended window: events visible 0.5s before start and 0.5s after end
  const activeEvents = events.filter(
    (event) => currentTime >= (event.start_sec - 0.5) && currentTime <= (event.end_sec + 0.5)
  );

  if (activeEvents.length === 0) return null;

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-20">
      {activeEvents.map((event) => {
        const { css_style } = event.spatial_overlay;

        // Strict window controls BOX visibility
        const isStrictTime = currentTime >= event.start_sec && currentTime <= event.end_sec;

        const mainColor = '#FFD700'; // Gold
        const secondaryColor = '#FF0000'; // Red

        return (
          <div key={event.id} className="absolute inset-0">

            {/* Bounding Box - fades in/out */}
            <div
              className={`absolute transition-opacity duration-300 ease-in-out ${isStrictTime ? 'opacity-100' : 'opacity-0'}`}
              style={{
                top: css_style.top,
                left: css_style.left,
                width: css_style.width,
                height: css_style.height,
              }}
            >
               {/* Soft Glass Effect */}
               <div
                 className="absolute inset-0 rounded-2xl border-2 shadow-[0_0_25px_rgba(255,215,0,0.3)] backdrop-blur-[1px]"
                 style={{
                    borderColor: 'rgba(255, 255, 255, 0.6)',
                    backgroundColor: 'rgba(255, 215, 0, 0.05)'
                 }}
               />

               {/* Corner Accents */}
               <div className="absolute top-0 left-0 w-3 h-3 border-t-2 border-l-2 border-white rounded-tl-xl opacity-80" />
               <div className="absolute top-0 right-0 w-3 h-3 border-t-2 border-r-2 border-white rounded-tr-xl opacity-80" />
               <div className="absolute bottom-0 left-0 w-3 h-3 border-b-2 border-l-2 border-white rounded-bl-xl opacity-80" />
               <div className="absolute bottom-0 right-0 w-3 h-3 border-b-2 border-r-2 border-white rounded-br-xl opacity-80" />
            </div>

            {/* Batman-Style Text Label */}
            <div
                className="absolute flex items-center justify-center w-full md:w-auto"
                style={{
                    top: `calc(${css_style.top} - 10px)`,
                    left: css_style.left,
                    width: css_style.width,
                    transform: 'translate(-10%, -50%)',
                }}
            >
                <div className="animate-comic-sequence relative">
                    {/* Background Splash Shape */}
                    <svg viewBox="0 0 200 100" className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[180%] h-[180%] opacity-90 z-0 drop-shadow-xl">
                         <path d="M10,50 Q30,20 50,40 T90,30 T130,40 T170,20 T190,50 Q170,80 150,60 T110,70 T70,60 T30,80 Z" fill={secondaryColor} stroke="black" strokeWidth="3" />
                    </svg>

                    {/* The Text */}
                    <h2
                        className="relative z-10 font-black text-4xl md:text-6xl uppercase leading-none text-center whitespace-nowrap transform -rotate-3"
                        style={{
                            color: mainColor,
                            WebkitTextStroke: '2px black',
                            textShadow: '4px 4px 0px #000'
                        }}
                    >
                        {event.title}
                    </h2>
                </div>
            </div>

          </div>
        );
      })}

      <style>{`
        @keyframes comicSequence {
          0% {
            transform: scale(0) rotate(-15deg);
            opacity: 0;
          }
          10% {
            transform: scale(1.2) rotate(-3deg);
            opacity: 1;
          }
          20% {
            transform: scale(1.0) rotate(-3deg);
            opacity: 1;
          }
          80% {
            opacity: 1;
            transform: scale(1.0) rotate(-3deg);
          }
          100% {
            transform: scale(1.1) rotate(0deg);
            opacity: 0;
          }
        }
        .animate-comic-sequence {
          animation: comicSequence 3s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default Overlay;
